import React from "react";
import { FontWeightEnum } from "../../types/AppTypes";
import { getVariantTextColor, StyledBadge } from "./BadgeChip.styled";
import { BodyTyp } from "../Typography/Typography";
import { useTheme } from "styled-components";

export enum BadgeVariant {
  PRIMARY = "primary",
  SECONDARY = "secondary",
}

export enum BadgeLabelSize {
  SMALL = "small",
  MEDIUM = "medium",
}

const SIZE_VARIANT: Record<BadgeLabelSize, "2" | "3"> = {
  [BadgeLabelSize.MEDIUM]: "2",
  [BadgeLabelSize.SMALL]: "3",
};

interface BadgeChipProps {
  children: React.ReactNode;
  size?: BadgeLabelSize;
  colorVariant?: BadgeVariant;
}

export const BadgeChip = ({
  children,
  size = BadgeLabelSize.SMALL,
  colorVariant = BadgeVariant.PRIMARY,
}: BadgeChipProps) => {
  const theme = useTheme();
  const textColor = getVariantTextColor(theme, colorVariant);
  return (
    <StyledBadge $colorVariant={colorVariant}>
      <BodyTyp
        fontWeight={FontWeightEnum.MEDIUM}
        variant={SIZE_VARIANT[size]}
        color={textColor}
      >
        {children}
      </BodyTyp>
    </StyledBadge>
  );
};
